export const money = (n) => {
  if (!n && n !== 0) return "—";
  const cents = Math.round(n * 100) % 100 !== 0;
  return `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: 2 })}`;
};

// same calendar as the invoice cron (US Eastern)
const localToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" });

export const daysLate = (due) => (due ? Math.round((new Date(`${localToday()}T00:00:00Z`) - new Date(`${due}T00:00:00Z`)) / 86400000) : 0);

export const partState = (info) => {
  if (info.paid_at) return "paid";
  if (!info.due_date) return "unset";
  const t = localToday();
  if (info.due_date < t) return "overdue";
  if (info.due_date === t) return "today";
  return "upcoming";
};

export const fmtDay = (s) => {
  if (!s) return "—";
  const d = s.length === 10 ? new Date(`${s}T12:00:00`) : new Date(s);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

export const paymentTotals = (payments) => {
  const t = { carrierExpected: 0, carrierReceived: 0, setterOwed: 0, setterSent: 0, dueNow: 0 };
  for (const p of payments) {
    for (const [part, info] of Object.entries(p.parts)) {
      const amt = info.amount || 0;
      const carrier = part.startsWith("carrier");
      if (carrier) t.carrierExpected += amt; else t.setterOwed += amt;
      if (info.paid_at) {
        if (carrier) t.carrierReceived += amt; else t.setterSent += amt;
      } else if (["overdue", "today"].includes(partState(info))) t.dueNow += 1;
    }
  }
  return t;
};

const etMonth = (iso) => new Date(iso).toLocaleDateString("en-CA", { timeZone: "America/New_York" }).slice(0, 7);

// current month first, then any earlier month with money movement
export const monthlyRevenue = (payments) => {
  const map = {};
  const row = (m) => (map[m] ||= { month: m, received: 0, setters: 0, fees: 0 });
  row(etMonth(new Date().toISOString()));
  for (const p of payments) {
    for (const [part, info] of Object.entries(p.parts)) {
      if (!info.paid_at) continue;
      const r = row(etMonth(info.paid_at));
      if (part.startsWith("carrier")) {
        r.received += info.amount || 0;
        r.fees += info.late_fee || 0;
      } else r.setters += info.amount || 0;
    }
  }
  return Object.values(map).sort((a, b) => b.month.localeCompare(a.month));
};

export const carrierStats = (payments) => {
  const map = {};
  for (const p of [...payments].reverse()) {
    if (!p.carrier_name) continue;
    const name = p.carrier_name.trim();
    const r = (map[name.toLowerCase()] ||= { name, drivers: 0, received: 0, owed: 0, paidHalves: 0, paidLate: 0, lateDays: 0, overdueNow: 0 });
    r.drivers += 1;
    for (const part of ["carrier_1", "carrier_2"]) {
      const info = p.parts[part];
      if (!info.amount) continue;
      if (info.paid_at) {
        r.received += info.amount;
        r.paidHalves += 1;
        if (info.working_days_late > 0) {
          r.paidLate += 1;
          r.lateDays += info.working_days_late;
        }
      } else {
        r.owed += info.total_due || info.amount;
        if (partState(info) === "overdue") r.overdueNow += 1;
      }
    }
  }
  return Object.values(map)
    .map((r) => ({ ...r, lateRate: r.paidHalves ? r.paidLate / r.paidHalves : 0, avgLate: r.paidLate ? r.lateDays / r.paidLate : 0 }))
    .sort((a, b) => b.received - a.received || b.owed - a.owed);
};
